import { type FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';

import { type RootState } from '@editor2/reducers/root';
import { updateChapter } from '@editor2/reducers/editor/editorSlice';
import { chapterSettings } from '@editor2/containers/ChapterPage/styles';
import { type Chapter } from '@editor2/types/chapter';

interface Props {
	courseId: number;
	chapter: Chapter;
}

const ChapterSettings: FC<Props> = (props) => {
	const { courseId, chapter } = props;

	const dispatch = useDispatch();

	const [chapterType, setChapterType] = useState(chapter.chapter_type);

	const { chapter_types } = useSelector((state: RootState) => state.courses[courseId].config);
	const chapterTypesKeys = Object.keys(chapter_types);

	useEffect(() => {
		setChapterType(chapter.chapter_type);
	}, [chapter.chapter_type]);

	const onChapterTypeChange = (chapterType: string) => {
		setChapterType(chapterType);
		dispatch(updateChapter({ chapterId: chapter.family_id, courseId, chapter_type: chapterType }));
	};

	return (
		<Form className={chapterSettings}>
			<Form.Group>
				<Form.Label>Chapter type</Form.Label>
				<Form.Control
					as="select"
					className="chapterTypeSelect"
					value={chapterType}
					onChange={(e) => onChapterTypeChange(e.target.value)}>
					{!chapter_types[chapterType]?.enabled && <option key={chapterType} value={''}></option>}

					{chapterTypesKeys.map(
						(type) =>
							chapter_types[type].enabled && (
								<option key={type} value={type}>
									{chapter_types[type].human_name}
								</option>
							)
					)}
				</Form.Control>
			</Form.Group>
		</Form>
	);
};

export default ChapterSettings;
